import script from "./Announcements.vue?vue&type=script&setup=true&lang=js"
export * from "./Announcements.vue?vue&type=script&setup=true&lang=js"

import "./Announcements.vue?vue&type=style&index=0&id=07debbf2&scoped=true&lang=css"

import exportComponent from "/Volumes/SSD/jenkins/workspace/Walk Online Mobile/Walk Online Admin/Walk Online Admin Prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07debbf2"]])

export default __exports__